import React from "react";

import PageContent from "ui/PageContent";
import Loading from "ui/Loading";
import Panel from "ui/Panel";

import { useCurrentServer } from "providers/WithCurrentOrganization";
import { useRoutes } from "utils/routes";
import { Link } from "react-router-dom";
import Grid from "ui/Grid";
import { useGetQueryAdvisorServerOverviewQuery } from "./gql/Query.generated";

const QueryAdvisorServerOverview = () => {
  const { databaseQueriesAdvisor } = useRoutes();
  const { humanId: serverId } = useCurrentServer();
  const { data, loading, error } = useGetQueryAdvisorServerOverviewQuery({
    variables: {
      serverId,
      checkGroupsAndNames: ["queries/advisor_insight"],
    },
  });

  if (loading || error) {
    return <Loading error={!!error} />;
  }

  const databases = data.getDatabases;

  return (
    <PageContent
      title="Query Advisor"
      pageCategory="index-advisor"
      pageName="server-index"
    >
      <Panel title="Databases">
        <Grid
          data={databases}
          striped
          columns={[
            {
              field: "datname",
              header: "Name",
              width: "minmax(250px,1fr)",
              renderer: function DatabaseCell({ rowData, fieldData }) {
                return (
                  <Link to={databaseQueriesAdvisor(rowData.id)}>
                    {fieldData}
                  </Link>
                );
              },
            },
            {
              field: "issueCount",
              header: "Queries with Insights",
              width: "minmax(10%,250px)",
              style: "number",
              renderer: function IssueCountCell({ rowData, fieldData }) {
                return (
                  <Link to={databaseQueriesAdvisor(rowData.id)}>
                    {fieldData}
                  </Link>
                );
              },
            },
            /* TODO: Show # of Workbooks with Insights here too */
          ]}
        />
      </Panel>
    </PageContent>
  );
};

export default QueryAdvisorServerOverview;
